import React from 'react';
// components
import ActionButton from './ActionButton';

const styles: any = {
  link: {
    display: "flex",
    color: "#627995",
    marginLeft: 20,

  },
  icon: {
    marginRight: 10
  },
  image: {
    marginRight: 10
  }
}

interface DividerProps {
  name: string;
  icon?: React.ReactNode;
  image?: string;
  onClick(): void;
}

const Divider: React.FC<DividerProps> = (props) => {

  const icon = (props.icon !== undefined ? <div style={styles.icon}>{props.icon}</div> : <img src={props.image} style={styles.image} alt="" />)

  return (
    <div style={styles.link} onClick={props.onClick}>
      {icon}
      <ActionButton
        textOnly
        name={props.name}
        onClick={props.onClick}
      />
    </div>
  )
}
export default Divider;


// WEBPACK FOOTER //
// ./src/components/buttons/IconButton.tsx